import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ListComponent } from './list.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { ListNavComponent } from './components/list-nav/list-nav.component';
import { ListNavItemComponent } from './components/list-nav-item/list-nav-item.component';
import { ListSelectionComponent } from './components/list-selection/list-selection.component';

@NgModule({
  declarations: [
    ListComponent,
    ListItemComponent,
    ListNavComponent,
    ListNavItemComponent,
    ListSelectionComponent,
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    ListComponent,
    ListItemComponent,
    ListNavComponent,
    ListNavItemComponent,
    ListSelectionComponent,
  ],
})
export class ListModule {}
